import React, {useState, useEffect, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import './view.css'
import {toast} from "react-toastify";
import {BaseUrl} from "../../../../contexts/baseUrl/baseUrl";
import FileUpload from "../../../sales/fileUpload/fileUpload";

const View = ({
                  match,
                  cxOrderRefundData,
                  orderRefundData=[],
                  cxOrderRefundApproval,
                  orderRefundActionData=[],
                  history,
                  documentUploadUrlPublic,
                  documentUrlDataPublic,
              }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessSModal, setIsSuccessModal] = useState(false);
    const [isRejectSModal, setIsRejectModal] = useState(false);
    const [remark, setRemark] = useState("")
    const [attachment, setAttachment] = useState("")
    const {baseUrl} = useContext(BaseUrl);

    useEffect(() => {
        (async () => {
            let roleId = localStorage.getItem('fusion-role')
            setIsLoading(true)
            await cxOrderRefundData(match?.params?.order_id, match?.params?.id, roleId)
            setIsLoading(false)
        }) ()
    }, [])

    const handleModalHide = () => {
        setIsSuccessModal(false)
        setIsRejectModal(false)
    }


    const handleAction = async (status) => {
        let obj = {
            status: status,
            request_id: match?.params?.id,
            order_id: match?.params?.order_id,
            remark: remark,
            category_id:orderRefundData?.request_refund?.category_id,
            category_name:orderRefundData?.request_refund?.category,
            role_id: localStorage.getItem('fusion-role'),
            attachment: attachment
        }

        setIsLoading(true)
        await cxOrderRefundApproval(obj)
        setIsLoading(false)
    }

	useEffect(() => {
        if (!orderRefundActionData || (Array.isArray(orderRefundActionData) && orderRefundActionData.length === 0)) {
            return;
        }
        const status = orderRefundActionData?.status;
        const ok =
            status === true ||
            Number(status) === 0 ||
            parseInt(status, 10) === 200 ||
            parseInt(orderRefundActionData?.status_code, 10) === 200;
        if (ok) {
            setTimeout(() => {
                toast.success(orderRefundActionData?.message)
            }, 100)
            history.push(`${baseUrl}/cx-refund-request`);
        } else {
            toast.error(orderRefundActionData?.message)
        }
    }, [orderRefundActionData])

    return (
        <>
            <Layout
                title={localization.CxRefundApproval}
                isGoback
                isLoading={isLoading}
            >
                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{'View'}</div>
                    <div className="panel-body panel-bg">
                        <div className="details-listing detail_alignment">
                            <h3>Order #{match?.params?.order_id}</h3>
                            {orderRefundData?.request_refund !== undefined &&
                                <div className="refund-request">
                                    <div className="refund-details">
                                        <p><b># Refund Request:</b></p>
                                        <p><b>Request Id: </b>{match?.params?.id}</p>
                                        <p><b>Request Type: </b> {orderRefundData?.request_refund?.type}</p>
                                        <p><b>Request Date/Time:</b> {orderRefundData?.request_refund?.created_at}</p>
                                        <p><b>Request Amount:</b> Rs {orderRefundData?.request_refund?.amount}</p>
                                    </div>
                                    <div className="request-remark">
                                        <p><b>Request Remarks</b></p>
                                        <p>{orderRefundData?.request_refund?.remarks}</p>
                                    </div>
                                </div>
                            }

                            <div className="refund-request">
                                <div className="order-details">
                                    <p><b># Order Overview: </b></p>
                                    <p><b>User Id: </b>{orderRefundData?.request_refund?.user_id}</p>
                                    <p><b>Category:</b> {orderRefundData?.request_refund?.category}</p>
                                    <p><b>Category Id:</b> {orderRefundData?.request_refund?.category_id}</p>
                                    <p><b>Order Date/Time:</b> {orderRefundData?.request_order?.created}</p>
                                </div>
                                <div className="order-details-two">
                                    <p></p><br/>
                                    <p><b>Order Id:</b> {match?.params?.order_id}</p>
                                    <p><b>Order Amount:</b> Rs {orderRefundData?.request_order?.total_price}</p>
                                    <p><b>Paid Amount:</b> Rs {orderRefundData?.request_order?.total_payble_amount}</p>
                                    <p><b>Order Status:</b> {orderRefundData?.request_order?.order_status}</p>
                                </div>
                            </div>
                            <div className="payment-details">
                                <p><b># Payment Details:</b></p>
                                <br/>
                                <table className="table table-border table-striped">
                                    <tr className="table-secondary">
                                        <th>Payment Method</th>
                                        <th>Payment Partner</th>
                                        <th>Payment Amount</th>
                                        <th>Payment App</th>
                                        <th>Payment Date/Time</th>
                                        <th>Payment Status</th>
                                    </tr>
                                    <tbody>
                                    {orderRefundData?.request_order?.payments !== undefined &&
                                        <>
                                            {orderRefundData?.request_order?.payments.map((val, i) => {
                                                return  (
                                                    <>
                                                        <tr>
                                                            <td>{val?.payment_method}</td>
                                                            <td>{val?.payment_partner_name}</td>
                                                            <td>{val?.amount}</td>
                                                            <td>{val?.payment_app}</td>
                                                            <td>{val?.created}</td>
                                                            <td><p className="success-status">{val?.payment_status}</p></td>
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                        </>
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className="order-items-details table-striped">
                                <p><b>#Order items details</b></p>
                                <table className="table table-border">
                                    <tr className="table-secondary">
                                        <th>Order ID</th>
                                        <th>Order Item ID</th>
                                        <th>Category ID</th>
                                        <th>Category Name</th>
                                        <th>Sku</th>
                                        <th>Quantity</th>
                                        <th>Unit Price</th>
                                        <th>Fulfilment Initiated On</th>
                                        <th>Fulfilment Success On</th>
                                        <th>Fulfilment Status</th>
                                        <th>Refund Status</th>
                                    </tr>
                                    <tbody>
                                    {orderRefundData?.request_order?.items !== undefined &&
                                        <>
                                            {orderRefundData?.request_order?.items.map((val, i) => {
                                                return  (
                                                    <>
                                                        <tr>
                                                            <td>{val?.order_id}</td>
                                                            <td>{val?.id}</td>
                                                            <td>{orderRefundData?.request_refund?.category_id}</td>
                                                            <td>{orderRefundData?.request_refund?.category}</td>
                                                            <td>{val?.sku}</td>
                                                            <td>{val?.quantity}</td>
                                                            <td>{val?.unit_price}</td>
                                                            <td>{val?.created}</td>
                                                            <td>{val?.created}</td>
                                                            <td>Success</td>
                                                            <td>{val?.refund_status}</td>
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                        </>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="refund-details-data table-striped">
                            <p><b># Refund Details:</b></p>
                            <p><b>Total amount paid:</b>{orderRefundData?.request_order?.total_payble_amount}</p>
                            <p><b>Cashback adjusted:</b>{orderRefundData?.request_order?.cashback}</p>
                            <table className="table table-border">
                                <tr className="table-secondary">
                                    <th>Refund ID</th>
                                    {/*<th>Refund Type</th>*/}
                                    <th>Refund Amount</th>
                                    <th>Initiated On</th>
                                    <th>Success At</th>
                                    <th>Updated At</th>
                                    <th>Refund Status</th>
                                </tr>
                                <tbody>
                                {orderRefundData?.request_order?.refunds !== undefined &&
                                    <>
                                        {orderRefundData?.request_order?.refunds.map((val, i) => {
                                            return  (
                                                <>
                                                    <tr>
                                                        <td>{val?.id}</td>
                                                        <td>{val?.refund_amount}</td>
                                                        <td>{val?.created}</td>
                                                        <td>{val?.created}</td>
                                                        <td>{val?.updated}</td>
                                                        <td>{val?.refund_status !== null  ? val?.refund_status : "---"}</td>
                                                    </tr>
                                                </>
                                            )
                                        })}
                                    </>
                                }
                                </tbody>
                            </table>
                        </div>
                        <div className="fulfillment-details table-striped">
                            <p><b># Fulfilment Details:</b></p>
                            <table className="table table-border">
                                <tr className="table-secondary">
                                    <th>Bill To</th>
                                    <th>Ship To</th>
                                    <th>Item Count</th>
                                </tr>
                                <tbody>
                                {orderRefundData?.request_order?.fulfilment_details !== undefined &&
                                    <>
                                        <tr>
                                            <td>{orderRefundData?.request_order?.fulfilment_details?.delivery_address?.name}, {orderRefundData?.request_order?.fulfilment_details?.delivery_address?.address_line_2}</td>
                                            <td>{orderRefundData?.request_order?.fulfilment_details?.billing_address?.name}, {orderRefundData?.request_order?.fulfilment_details?.billing_address?.address_line_2}</td>
                                            <td>{orderRefundData?.request_order?.items.length}</td>
                                        </tr>
                                    </>
                                }
                                </tbody>
                            </table>
                        </div>
                        <ModalPop
                            title='Are you sure want to approve the refund?'
                            show={isSuccessSModal}
                            handleModalHide={handleModalHide}
                        >
                            <div className="">
                                <h5>Refund Amount: {orderRefundData?.request_refund?.amount}</h5>
                                <h5>Category: {orderRefundData?.request_refund?.category}</h5>
                                <textarea rows="6" cols="4" onChange={(e) => {setRemark(e.target.value)}}></textarea>
                                <div className="col-md-4">
                                    <FileUpload
                                        id="profile"
                                        accept=".pdf,.png,.jpg,.jpeg,.doc, .xlsx,.csv,.doc,.pdf"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) =>
                                            setAttachment(val)
                                        }
                                    >
                                        <span className="btn btn-transparent">
                                            {localization.attachment}
                                        </span>
                                    </FileUpload>
                                </div>
                                <div className="approve-button">
                                    <button type="button" className="btn btn-lg btn-success" onClick={(e) => {handleAction(1)}}>Confirm</button>
                                    <button type="button" className="btn btn-lg btn-danger" onClick={() => {setIsSuccessModal(false)}}>Cancel</button>
                                </div>
                            </div>
                        </ModalPop>
                        <ModalPop
                            title='Are you sure want to reject the refund?'
                            show={isRejectSModal}
                            handleModalHide={handleModalHide}
                        >
                            <div className="">
                                <h5>Refund Amount: {orderRefundData?.request_refund?.amount}</h5>
                                <h5>Category: {orderRefundData?.request_refund?.category}</h5>
                                <h4>why are you rejecting the refund?</h4>
                                <textarea rows="6" cols="4" onChange={(e) => {setRemark(e.target.value)}}></textarea>
                                <div className="col-md-4">
                                    <FileUpload
                                        id="profile"
                                        accept=".pdf,.png,.jpg,.jpeg,.doc, .xlsx,.csv,.doc,.pdf"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) =>
                                            setAttachment(val)
                                        }
                                    >
                                        <span className="btn btn-transparent">
                                            {localization.attachment}
                                        </span>
                                    </FileUpload>
                                </div>
                                <div className="approve-button">
                                    <button type="button" className="btn btn-lg btn-success" onClick={(e) => {handleAction(0)}}>Confirm</button>
                                    <button type="button" className="btn btn-lg btn-danger" onClick={() => {setIsRejectModal(false)}}>Cancel</button>
                                </div>
                            </div>
                        </ModalPop>

                    </div>
                    <div className="action-button">
                        <button type="button" className="btn btn-lg btn-success" onClick={() => {setIsSuccessModal(true)}}>Approve</button>
                        <button type="button" className="btn btn-lg btn-danger" onClick={() => {setIsRejectModal(true)}}>Reject</button>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export default View